// F1 Awards Component
import React, { useState } from 'react';
import { TableChart } from '../charts';

const AwardsComponent = ({ data }) => {
  const [activeView, setActiveView] = useState('overview');
  const [selectedYear, setSelectedYear] = useState(null);

  return (
    <>
      <div className="mt-8">
        <h3 className="text-xl font-semibold theme-primary mb-4">World Champions</h3>
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">
            Driver championship history and records will be displayed here. This section will show 
            detailed information about Formula 1 World Champions including their championship years, 
            race wins, and career achievements.
          </p>
          <TableChart 
            data={data?.driver_standings || []}
            config={{
              columns: [
                { key: 'driverId', label: 'Driver ID' },
                { key: 'points', label: 'Points' },
                { key: 'wins', label: 'Wins' },
                { key: 'position', label: 'Position' }
              ],
              sortable: true,
              searchable: true,
              sortBy: 'points',
              sortDirection: 'desc',
              pagination: true,
              pageSize: 10
            }}
          />
        </div>
      </div>

      <div className="mt-8">
        <div className="theme-bg-secondary rounded-lg p-4">
          <h3 className="text-xl font-semibold theme-primary mb-4">Constructor Champions</h3>
          <p className="theme-secondary">
            Constructor championship history and team achievements will be displayed here. 
            This section will cover team championships, dominant eras, and manufacturer success.
          </p>
          <TableChart 
            data={data?.constructor_standings || []}
            config={{
              columns: [
                { key: 'constructorId', label: 'Constructor ID' },
                { key: 'points', label: 'Points' },
                { key: 'wins', label: 'Wins' },
                { key: 'position', label: 'Position' }
              ],
              sortable: true,
              searchable: true,
              sortBy: 'points',
              sortDirection: 'desc',
              pagination: true,
              pageSize: 10
            }}
          />
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-xl font-semibold theme-primary mb-4">Special Awards</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="theme-bg-secondary rounded-lg p-4">
            <h4 className="font-semibold theme-primary mb-2">Rookie of the Year</h4>
            <p className="theme-secondary text-sm">
              Outstanding debut performances and rookie achievements throughout F1 history.
            </p>
          </div>
          <div className="theme-bg-secondary rounded-lg p-4">
            <h4 className="font-semibold theme-primary mb-2">Special Recognition</h4>
            <p className="theme-secondary text-sm">
              Honorary awards, lifetime achievement awards, and special commendations.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-xl font-semibold theme-primary mb-4">Records & Milestones</h3>
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">
            Historical records, milestone achievements, and statistical highlights from 
            Formula 1's rich history including most wins, championships, and special accomplishments.
          </p>
        </div>
      </div>
    </>
  );
};

export const awardsConfig = {
  title: 'F1 Awards',
  subtitle: 'Championship titles, awards, and special achievements from Formula 1 history',
  summary: ['World championships', 'Special awards', 'Historical achievements'],
  stats: [
    { 
      value: '74', 
      label: 'Driver Championships',
    },
    { 
      value: '65', 
      label: 'Constructor Titles',
    },
    { 
      value: '34', 
      label: 'Unique Drivers',
    },
    { 
      value: '15', 
      label: 'Unique Teams',
    }
  ],
  component: AwardsComponent
};

export default AwardsComponent;
